import styled from "styled-components";
import { Link } from "react-router-dom";

import { Container } from "react-bootstrap";
import { Skeleton } from "@mui/material";

export const Wrapper = styled(Container)`
  max-width: 690px;
  @media screen and (max-width: 756px) {
    width: 100%;
  }
  .Company-cards-skeleton {
    border-radius: 10px;
    height: 230px;
    height: 140px;
    @media screen and (max-width: 576px) {
      height: 170px;
    }
  }
  .discount-package{
    color:var(--primary-color);
  }
`;
export const StyledCompanyCardsWrapper = styled.div`
  width: 92%;
  display: grid;
  grid-template-columns: repeat(4, calc(100% / 4));
  gap: 16px;
  justify-content: center;
  @media screen and (max-width: 756px) {
    width: 100%;
    grid-template-columns: repeat(3, calc(100% / 3));
    gap: 10px;
  }
  @media screen and (max-width: 400px) {
    grid-template-columns: repeat(2, calc(100% / 2));
  }
  .submit-button {
    align-self: end;
    width: 80%;
    @media screen and (max-width: 756px) {
      grid-column-end: span 3;
    }
  }
`;
export const StyledCreateNewCompany = styled(Link)`
  height: 140px;
  border: 1.5px solid #a4adbc;
  border-radius: 10px;
  font-size: var(--font-size-base);
  color: var(--tertiary-color);
  @media screen and (max-width: 576px) {
    width: 112px;
    height: 100px;
    font-size: var(--font-size-xs);
  }
`;
export const StyledContainer = styled(Container)`
  p {
    text-align: center;
  }
  button {
    font-size: var(--font-size-xs);
    height: 40px;
    color: var(--white-color);
    background: var(--tertiary-color);
    border: 1px solid var(--tertiary-color);
    border-radius: 8px;
    &:hover {
      color: var(--white-color);
      background: var(--tertiary-color);
    }
    &:focus {
      outline: none;
      color: var(--white-color);
      background: var(--tertiary-color);
    }
  }
  .delete-button {
    font-size: var(--font-size-xs);
    border: 1px solid var(--tertiary-color);
    background: var(--bg-color);
    color: var(--tertiary-color);
    &:hover {
      background: var(--bg-color);
      color: var(--tertiary-color);
    }
    &:focus {
      background: var(--bg-color);
      color: var(--tertiary-color);
    }
  }
`;
export const StyledSkeleton = styled(Skeleton)`
  height: 200px;
  @media screen and (max-width: 576px) {
    height: 100px;
    font-size: var(--font-size-xs);
  }
`;
